import React from 'react';

const SuccessfulOperationIndicator = () => {
  return (
    <svg
      width='256'
      height='146'
      viewBox='0 0 256 146'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M163.943 121.663C155.434 126.354 145.655 129.023 135.252 129.023C120.18 129.023 106.416 123.42 95.9308 114.184C90.2082 118.178 83.2473 120.521 75.7393 120.521C56.2329 120.521 40.4199 104.708 40.4199 85.2013C40.4199 65.6949 56.2329 49.8819 75.7393 49.8819C76.8393 49.8819 77.9276 49.9322 79.002 50.0306C87.0703 26.7306 109.207 10 135.252 10C166.96 10 192.876 34.7973 194.665 66.057C211.531 66.9225 225.271 79.6199 227.747 96.0107C237.646 96.1033 245.643 104.157 245.643 114.078C245.643 124.057 237.553 132.147 227.574 132.147C223.179 132.147 219.15 130.577 216.017 127.968C209.813 133.374 201.701 136.649 192.825 136.649C180.889 136.649 170.336 130.728 163.943 121.663ZM25.46 124.592C33.7221 124.592 40.4199 117.894 40.4199 109.632C40.4199 101.37 33.7221 94.6722 25.46 94.6722C17.1978 94.6722 10.5 101.37 10.5 109.632C10.5 117.894 17.1978 124.592 25.46 124.592Z'
        fill='#E0E9F2'
      />
      <path
        d='M154.359 51.1116L126.926 78.545L111.981 63.6419L106.112 69.5115L126.926 90.3259L160.229 57.0229L154.359 51.1116ZM135.252 27.8828C112.273 27.8828 93.623 46.5325 93.623 69.5115C93.623 92.4906 112.273 111.14 135.252 111.14C158.231 111.14 176.881 92.4906 176.881 69.5115C176.881 46.5325 158.231 27.8828 135.252 27.8828ZM135.252 102.815C116.852 102.815 101.949 87.9114 101.949 69.5115C101.949 51.1116 116.852 36.2086 135.252 36.2086C153.652 36.2086 168.555 51.1116 168.555 69.5115C168.555 87.9114 153.652 102.815 135.252 102.815Z'
        fill='#0177B5'
      />
    </svg>
  );
};

export default SuccessfulOperationIndicator;
